// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-934fa4d7c6cc5308.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "882ad3a2cab5f295" + ".js";
};